// extracted by mini-css-extract-plugin
export default {"component":"HomeTiles_component__AsGNa"};